import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import { Section, Title } from "../../components/Common/PageElement";
import { Container, Col } from "react-bootstrap";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    useRouteMatch,
    useHistory,
} from "react-router-dom";
import Fade from "react-reveal/Fade";
import UploaderComponent, {
    UploadPreview,
} from "../../components/UploadComponent";
import { AnnotreeSearchRow } from "./StyledAnnotreeSearch";
import TextComponent from "../../components/TextComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { DropdownMenu, Textbox } from "../../components/Form";
import {
    ANNOTOOL_APPLICATION,
    ANNOTREE_DATABASE,
    ANNOTREE_INTERMEDIATE,
    SEARCH_MODE,
    STOP_LOADER
} from "../../services/Constant";
import { LoadContext } from "../../context/LoadContext";
import { TokenService } from "../../services/Token";
import {
    SERVER_URL,
    INTERMEDIATE_API,
    EMAIL_SERVICE_ID,
    EMAIL_TEMPLATE_ID_1,
    EMAIL_USER_ID,
    QUEUE_CHECK, SERVER_PREFIX
} from "../../services/Config";
import Intermediate from "./Intermediate";
import emailjs from 'emailjs-com';
import validator from 'validator';



const AnnotreeSearch = () => {
    const { load,setLoad } = useContext(LoadContext);
    let { path } = useRouteMatch();
    let history = useHistory();

    const [evalue, setEvalue] = useState('0.00001');

    const [coverage, setCoverage] = useState('50');
    // const [contextRange, setContextRange] = useState('10000');

    const [databaseValue, setDatabaseValue] = useState(
        ANNOTREE_DATABASE[1]["id"]
    );


    const [searchMode, setSearchMode] = useState(
        SEARCH_MODE[0]["id"]
    );

    const [dataFiles, setDataFiles] = useState([]);
    const [dataText, setDataText] = useState("");

    const [userEmail,setUserEmail] = useState("");
    const [emailLabel,setEmailLabel] = useState("Email notification");
    const [checkSubmit,setCheckSubmit] = useState(false);



    const [queueLength,setQueueLength] = useState(0);
    const [maxLength,setMaxLength] = useState(0)



    // **************************************************** divider ***************************************

    const [pageToken, setPageToken] = useState('')


    const faqAddress = `${SERVER_PREFIX}/FAQ#Search0`
    const contactAddress = `${SERVER_PREFIX}/FAQ#General1`


    // **************************************************** divider ***************************************

    const dataFileCallback = (file) => {
        setDataFiles((prevFiles) => [...prevFiles, file]);
    };
    const dataTextCallback = (text) => {
        setDataText(text);
    };

    const dataRemoveFileCallback = (fileName) => {
        const dataFileIndex = dataFiles.findIndex((e) => e.name === fileName);
        dataFiles.splice(dataFileIndex, 1);
        setDataFiles([...dataFiles]);
    };
    //
    // const isValidIntContextRange = (str) => {
    //     const intVal = parseInt(str, 10);
    //     return Number.isInteger(intVal) && intVal >= 0
    // };


    const validateEmail = (e) => {

        // if(e.target.value.length === 0){
        //     setEmailLabel("Email notification")
        // }

        if(validator.isEmail(e.target.value)){
            setUserEmail(e.target.value)
            setEmailLabel("Valid Email :)")
        }
        else{
            setUserEmail("")
            setEmailLabel("Please check email format.")
        }
    }

    const sendEmail = () =>{
        // e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it
        emailjs.init(EMAIL_USER_ID);
        var templateParams = {
            name: userEmail,
        };
        emailjs.send(EMAIL_SERVICE_ID, EMAIL_TEMPLATE_ID_1,templateParams)
            .then((result) => {
                console.log("success")
               // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault() cancelled that behavior)
            }, (error) => {
                console.log(error.text);
            });
    }

    const isValidFloat = (str) => {
        const num = parseFloat(str);
        return !isNaN(num) && String(num) === str;
    };

    const isValidIntCoverage = (str) => {
        const intVal = parseInt(str, 10);
        return Number.isInteger(intVal) && intVal >= 0 && intVal <= 100
    };

    const search = () => {

        // if(queueLength >= maxLength){
        //     alert('sorry, too many requests, please wait until the number of jobs less than maximum capacity')
        //     return
        // }
        if(dataText.length === 0){
            alert('please enter your sequence')
            return
        }

        //
        // if (contextRange === "" || !isValidIntContextRange(contextRange)) {
        //     alert('Please enter the correct context range value as an integer.')
        //     return
        // }
        //
        // let intContextRange = parseInt(contextRange)
        // if(intContextRange < 5000 || intContextRange > 20000){
        //     alert('Context range con only between 5000 and 20000')
        //     return
        // }
        //


        if (evalue === "" || !isValidFloat(evalue)) {
            alert('Please enter the e-value in either float format or scientific notation.')
            return
        }

        if (coverage === "" || !isValidIntCoverage(coverage)) {
            alert('Please enter the correct coverage value as an integer.')
            return
        }

        const token = TokenService(40);

        setPageToken(token)
        setLoad({'value':ANNOTREE_INTERMEDIATE,'token':token,'database':databaseValue,'path':path});



        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", databaseValue);
        formData.append("sequence_text", dataText);
        formData.append("evalue", evalue);
        formData.append("coverage", coverage);
        formData.append("debug", false);

        formData.append("mode", searchMode);

        dataFiles.forEach((file) => {
            formData.append("sequence", file);
        });

        // console.log(INTERMEDIATE_API)
        // console.log(token)

        axios
            .post(SERVER_URL + INTERMEDIATE_API, formData)
            .then((response) => {
                // console.log('get response')
                // setLoad({'value':0,'token':''});
                console.log('submit success')
                // console.log(response.data)

            })
            .catch((e) => {
                console.log('Annotree search error')
                setLoad({'value':STOP_LOADER,'token':'','database':''});
                console.log(e)
                // alert("SEARCH ERROR");
            });
    };




    useEffect(() => {
        checkQueue()
    }, []);


    // useEffect(() => {
    //     console.log('state print:')
    //     console.log(pageToken)
    // }, []);


    const checkQueue = () =>{
        axios
            .get(SERVER_URL + QUEUE_CHECK)
            .then((response) => {
                console.log('checkQueue')
                let result = response.data.result
                let pro_length = response.data.length
                console.log(pro_length)
                setQueueLength(pro_length)
                setMaxLength(response.data.max_length)

            })
            .catch((e) => {
                console.log(e)
                console.log("queue check error")
                // alert("queue check error");
            });
    }

    return (
        <Switch>
            <Route exact path={path}>
                <Section height="full">
                    <Container>
                        <Fade top duration={1000} delay={600} distance="15px">
                            {/*<Title>Annotree Search</Title>*/}
                            <Title>Search GTDB</Title>
                        </Fade>

                        <Fade duration={1000} delay={600}>
                            <div  style={{ textIndent: "34em" }}>
                                <h6>
                                    Number of jobs in the queue: {queueLength}, maximum capacity: {maxLength}
                                </h6>
                                <p style={{color:'red', textIndent: "20em",fontSize:"15px"}}>Server is currently in beta and the queue will increase in size in later versions.</p>
                            </div>
                        </Fade>

                        <Fade duration={1000} delay={600}>
                            <AnnotreeSearchRow>
                                {/*<Col>*/}
                                {/*    <UploaderComponent*/}
                                {/*        title="Upload your FAST file"*/}
                                {/*        tooltip="Ensure your files are in the format of FAST."*/}
                                {/*        fileCallback={dataFileCallback}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                                <Col>
                                    <TextComponent
                                        // title="Enter your FASTA sequence"
                                        title={"Enter your protein sequence in FASTA format"}
                                        tooltip="Copy and paste your FASTA sequence into the text field."
                                        textCallback={dataTextCallback}
                                    />
                                </Col>
                            </AnnotreeSearchRow>
                            <>
                                {dataFiles.length !== 0 && (
                                    <AnnotreeSearchRow>
                                        <Col>
                                            <UploadPreview
                                                files={dataFiles}
                                                removeFileCallback={
                                                    dataRemoveFileCallback
                                                }
                                            />
                                        </Col>
                                    </AnnotreeSearchRow>
                                )}
                            </>
                            <AnnotreeSearchRow>
                                <Col>
                                    <Textbox
                                        defaultvalue={evalue}
                                        formlabel="E-value (max 1.0)"
                                        placeholder="Enter your e-value"
                                        onChange={(e) =>
                                            setEvalue(e.target.value)
                                        }
                                        showDetail={false}
                                    />
                                </Col>
                                {/*<Col>*/}
                                {/*    <Textbox*/}
                                {/*        defaultvalue={coverage}*/}
                                {/*        formlabel="Coverage threshold (max 100)"*/}
                                {/*        // formlabel={"Minimum query coverage of the alignment"}*/}
                                {/*        placeholder="Enter your coverage value"*/}
                                {/*        onChange={(e) =>*/}
                                {/*            setCoverage(e.target.value)*/}
                                {/*        }*/}
                                {/*        showDetail={true}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                                {/*<Col>*/}
                                {/*    <Textbox*/}
                                {/*        defaultvalue={contextRange}*/}
                                {/*        formlabel="Gene neighborhood context range (between 5000 and 20000)"*/}
                                {/*        // formlabel={"Minimum query coverage of the alignment"}*/}
                                {/*        placeholder="Enter your context range"*/}
                                {/*        onChange={(e) =>*/}
                                {/*            setContextRange(e.target.value)*/}
                                {/*        }*/}
                                {/*        showDetail={true}*/}
                                {/*        tooltipContent={'find annotations that within +/- bases of center gene'}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                                <Col>
                                    <DropdownMenu
                                        options={ANNOTREE_DATABASE}
                                        val="id"
                                        label="name"
                                        formlabel="Database"
                                        onChange={(event) =>
                                            setDatabaseValue(event.target.value)
                                        }
                                        value={databaseValue}
                                    />
                                </Col>
                            </AnnotreeSearchRow>
                            <AnnotreeSearchRow>
                                {/*<Col md={{ span: 4, offset: 4 }}>*/}
                                {/*    <Textbox*/}
                                {/*        // defaultvalue={""}*/}
                                {/*        formlabel={emailLabel}*/}
                                {/*        placeholder="Enter your email (optional)"*/}
                                {/*        onChange={validateEmail*/}
                                {/*        }*/}
                                {/*        showDetail={false}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                                <Col>
                                    <Textbox
                                        defaultvalue={coverage}
                                        formlabel="Coverage threshold (max 100)"
                                        // formlabel={"Minimum query coverage of the alignment"}
                                        placeholder="Enter your coverage value"
                                        onChange={(e) =>
                                            setCoverage(e.target.value)
                                        }
                                        showDetail={true}
                                    />
                                </Col>
                                <Col>
                                    <DropdownMenu
                                        options={SEARCH_MODE}
                                        val="id"
                                        label="name"
                                        formlabel="SearchMode"
                                        onChange={(event) =>
                                            setSearchMode(event.target.value)
                                        }
                                        value={searchMode}
                                    />
                                </Col>
                                {/*<Col>*/}
                                {/*    <Textbox*/}
                                {/*        defaultvalue={contextRange}*/}
                                {/*        formlabel="Gene neighborhood range (between 5000 and 20000)"*/}
                                {/*        // formlabel={"Minimum query coverage of the alignment"}*/}
                                {/*        placeholder="Enter your context range"*/}
                                {/*        onChange={(e) =>*/}
                                {/*            setContextRange(e.target.value)*/}
                                {/*        }*/}
                                {/*        showDetail={true}*/}
                                {/*        tooltipContent={'find annotations that within +/- bases of center gene'}*/}
                                {/*    />*/}
                                {/*</Col>*/}
                            </AnnotreeSearchRow>
                            <AnnotreeSearchRow>
                                <Col md={{ span: 6, offset: 3 }}>

                                    <ButtonComponent
                                        fill
                                        disabled={
                                            dataFiles.length === 0 &&
                                            dataText === ""
                                                ? true
                                                : false
                                        }
                                        onClick={search}
                                    >
                                        Search
                                    </ButtonComponent>
                                </Col>
                            </AnnotreeSearchRow>
                            <AnnotreeSearchRow>
                                <a style={{ paddingLeft: '20px' ,fontSize:'12px'}}>
                                    Have questions about the input?
                                    Please see our &nbsp;
                                    <a href={faqAddress} style={{ color: 'blue', textDecoration: 'underline' }}>FAQ page</a>
                                    &nbsp;
                                    or
                                    &nbsp;
                                    <a href={contactAddress} style={{ color: 'blue', textDecoration: 'underline' }}>contact us!</a>
                                </a>
                            </AnnotreeSearchRow>
                        </Fade>
                    </Container>
                </Section>
            </Route>
            <Route path={`${path}/intermediate`}>
                <Intermediate />
            </Route>
        </Switch>
    );
};

export default AnnotreeSearch;